// extracted by mini-css-extract-plugin
export default {"skeleton":"LazyImage_skeleton__7BaUO","shimmer":"LazyImage_shimmer__2R-YE","img":"LazyImage_img__xZYZH","loaded":"LazyImage_loaded__4GNbn"};